import React from 'react';
import Modal from '../../../../components/Modal';

const TrackingModal = ({ 
  isOpen, 
  onClose, 
  onSubmit, 
  isSubmitting, 
  order 
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Confirmer le suivi"
      onSubmit={onSubmit}
      submitLabel="Suivre"
      isSubmitting={isSubmitting}
      size="md"
    >
      <div className="py-4">
        <div className="flex items-center justify-center text-teal-500 mb-4">
          <svg className="h-12 w-12" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
          </svg>
        </div>

        <h3 className="text-lg font-medium text-center text-gray-900 mb-2">
          Suivre cette commande
        </h3>
        <div className="mt-2">
          <p className="text-sm text-gray-500 text-center">
            Vous êtes sur le point de suivre la commande {order?.reference || order?.id}. 
            Voulez-vous continuer?
          </p>
          
          {/* Display order details */}
          {order && (
            <div className="mt-4 p-3 bg-gray-50 rounded-lg text-left">
              <div className="flex justify-between mb-1">
                <span className="text-sm font-medium">Client:</span>
                <span className="text-sm">{order.clientFirstName} {order.clientLastName}</span>
              </div>
              <div className="flex justify-between mb-1">
                <span className="text-sm font-medium">Téléphone:</span>
                <span className="text-sm">{order.clientNumber || 'Non spécifié'}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-sm font-medium">Total:</span>
                <span className="text-sm">{(order.totalTTC || 0).toFixed(2)} TND</span>
              </div>
            </div>
          )}
        </div>

        <div className="bg-amber-50 border-l-4 border-amber-400 p-4 mt-4">
          <div className="flex">
            <svg className="h-5 w-5 text-amber-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
            </svg>
            <div className="ml-3">
              <p className="text-sm text-amber-700">
                Cette action lancera une demande de suivi pour cette commande et peut générer des notifications au client.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default TrackingModal;